module.exports = __webpack_public_path__ + "static/full-tree-a748833bae24cbd88e39e63a98bd326f.jpg";